const publicationCategoryFilterOptions = [
    {
      value: "LEGAL_AND_POLICY",
      label: "Legal & Policy"
    },
    {
      value: "RESEARCH",
      label: "Research"
    },
    {
      value: "REPORTS",
      label: "Reports"
    },
    {
      value: "GUIDELINES",
      label: "Guidelines"
    },
    {
      value: "ANNUAL_REPORTS",
      label: "Annual Reports"
    },
    {
      value: "STRATEGIC_DOCUMENTS",
      label: "Strategic Documents"
    },
    {
      value: "TECHNICAL_PAPERS",
      label: "Technical Papers"
    },
    {
      value: "DATA_AND_ANALYTICS",
      label: "Data & Analytics"
    },
    {
      value: "PROCUREMENT_DOCUMENTS",
      label: "Procurement Documents"
    },
    {
      value: "PROGRAMME_DOCUMENTS",
      label: "Programme Documents"
    },
    {
      value: "MISSION_BRIEFS",
      label: "Mission Briefs"
    },
    {
      value: "EDUCATION_AND_CAPACITY_BUILDING",
      label: "Education & Capacity Building"
    },
    {
      value: "ENVIRONMENTAL_AND_CLIMATE",
      label: "Environmental & Climate"
    },
    {
      value: "REGIONAL_DEVELOPMENT",
      label: "Regional Development"
    },
    {
      value: "PARTNERSHIPS_AND_COOPERATION",
      label: "Partnerships & Cooperation"
    },
    {
      value: "GOVERNANCE",
      label: "Governance"
    },
    {
      value: "DESIGN_AND_BRAND_ASSETS",
      label: "Design & Brand Assets"
    },
    {
      value: "INTERNAL_PUBLICATIONS",
      label: "Internal Publications"
    },
    {
      value: "APPLICATION_DOCUMENTS",
      label: "Application Documents"
    },
    {
      value: "OTHER",
      label: "Other"
    }
  ]

export default publicationCategoryFilterOptions;